module.exports = __webpack_public_path__ + "7e50081c56e6c100ec4b4fbb7fc399aa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-4.png
 ** module id = 1032
 ** module chunks = 0
 **/